import React from 'react';
import { Rate } from '@spike/boarding-rule-model';
import { RateRuleCard } from '../RateRuleCard/RateRuleCard';
import styles from './RateRulesList.module.scss';

interface RateRulesListProps {
    rateRules: Rate[];
}

export const RateRulesList: React.FC<RateRulesListProps> = ({ rateRules }) => {
    return (
        <div className={styles.container}>
            {rateRules.map((rateRule, index) => (
                <div
                    key={rateRule.uuid}
                    style={{ position: 'relative', zIndex: rateRules.length - index }}
                >
                    <RateRuleCard rateRule={rateRule} />
                </div>
            ))}
        </div>
    );
};
